import { Injectable } from '@angular/core';
import type { ItemsService } from '@app/@classes/abstract/items-service-interface';
import { ItemsViewServiceBase } from '@app/@classes/abstract/items-view-service';
import type { TablesKeys, Views } from '../../@classes/supabase';
const VIEW = 'notifications_with_details';
type T = typeof VIEW;
@Injectable({
  providedIn: 'root',
})
export class NotificationsWithDetailsService
  extends ItemsViewServiceBase<Views<T>>
  implements ItemsService<Views<T>> {
  public override realtimeReferenceTables: TablesKeys[] = ['notifications'];

  constructor() {
    super(VIEW, { hasTenant: true });
  }

  override defaultItem(): Views<T> {
    return {
      alert_id: null,
      barcode: null,
      created_at: null,
      deadline_id: null,
      id: null,
      is_read: null,
      message: null,
      pallet_id: null,
      read_at: null,
      tenant_id: null,
      outgoing_order_id: null,  
      outgoing_order_document_reference: null,
      outgoing_order_internal_identifier: null,
      title: null,
      pallet_company_name: null,
      pallet_packages_count: null,
      pallet_status: null,
      udc: null,
      user_id: null,
      type: null,
      alert_created_at: null,
      deadline_created_at: null,
      template_name: null,
      expiration_date: null,
      subject_name: null,
    };
  }
}
